import { HELPER_FUNCTIONS } from "@/utils/index"

export const instance = {
  api: HELPER_FUNCTIONS.apiInstance,
  form: HELPER_FUNCTIONS.formInstance,
  state: HELPER_FUNCTIONS.stateInstance,
}